import React from 'react';

const Programas = () => {
  return (
    <div>
      <h1>Programas</h1>
    </div>
  );
};

export default Programas;